import type { BariatricsExternalReferralData } from '@common/validation/customControls/bariatrics/bariatricsExternalReferral/v1/bariatricsExternalReferralSchema';

export const initialData: BariatricsExternalReferralData = {
    assets: [],
    datum_verwijzing: null,
    naam_externe_behandelaar: null,
    reden_doorverwijzing: null,
    type_behandelaar: null,
    type_behandelaar_overig: null,
};
